<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "scene",
      key: 'id',
      url: {
        get: '/admin/system/scene',
        add: '/admin/system/scene',
        edit: '/admin/system/scene',
      },
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "巡检项名称",
          name: "sceneName",
          value: "",
          type: "input",
          width: '400px',
          rules: [{ required: true, trigger: "blur" }],
        },
        // {
        //   label: "场景地址",
        //   name: "address",
        //   value: "",
        //   type: "input",
        //   width:'400px',
        //   rules: [{ required: true, trigger: "blur" }],
        // },
        // { label: "备注", name: "remark", value: "", type: "textarea" },
      ],
      forms: {},
    };
  },
  created() {

  },
  methods: {

  },
};
</script>
